import { Component, OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { EnvService } from '../env.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  appVersion:string;
  showAppVersion: boolean;
  footerText: string;

  constructor(private workspaceService:WorkspaceService, private env:EnvService) { 
    this.showAppVersion = this.env.showAppVersion;
    this.footerText = this.env.footerText;
  }

  ngOnInit() {
    this.workspaceService.getAppVersion().subscribe(result => {
      this.appVersion = result;
    })
  }

}
